export let notJunk = "HN$nC";
export default {notJunk};